import React from "react";

export default function StatCard({ title, value, hint, icon }) {
  return (
    <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-5 shadow-2xl">
      <div className="flex items-center justify-between">
        <div className="text-white/70 text-sm">{title}</div>
        <div className="text-lg">{icon}</div>
      </div>
      <div className="mt-2 text-white text-2xl font-semibold">{value}</div>
      {hint ? <div className="mt-1 text-white/60 text-sm">{hint}</div> : null}
    </div>
  );
}
